import { render, staticRenderFns } from "./settle-manage.vue?vue&type=template&id=246c1f1c"
import script from "./settle-manage.vue?vue&type=script&lang=ts"
export * from "./settle-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports